import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import SupportedIndustriesSection from "./components/SupportedIndustriesSection";
import PricingSection from "./components/PricingSection";

const pageStyle = {
  minHeight: "100dvh",        // dynamic viewport height (mobile-safe)
  width: "100vw",             // force full viewport width
  overflowX: "hidden",        // prevent right-side gutter
  background:
    "linear-gradient(180deg, #f8fafc 0%, #f0fdf4 35%, #ffffff 100%)",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  color: "#0f172a",
  margin: 0,
  padding: 0,
};


export default function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  async function handleLoginSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        "https://api.showmeyourjunk.biz/api/vendor/login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.success) {
        alert(data.error || "Login failed. Check email and password.");
        setLoading(false);
        return;
      }

      localStorage.setItem("vendor_token", data.vendor_token);
      localStorage.setItem("vendor_id", data.vendor_id);
      navigate("/dashboard");
    } catch (err) {
      console.error("Login error:", err);
      alert("A network or server error occurred.");
    }

    setLoading(false);
  }

  return (
    <div style={pageStyle}>
      <div style={{ padding: 12, maxWidth: 1200, margin: "0 auto" }}>
        {/* HERO HEADER */}
        <section style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: 42,
              fontWeight: 700,
              letterSpacing: "-0.02em",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Kevin's Leads
          </div>

       
          <div
            style={{
              fontSize: 17,
              maxWidth: 720,
              marginTop: 8,
              textAlign: isMobile ? "center" : "left",
              color: "#334155",
            }}
          >
            An AI-powered estimate and intake system that works directly on your
            website.
          </div>
        </section>

        {/* HERO IMAGE + LOGIN */}
        <section
          style={{
            marginTop: 10,
            position: "relative",
            background:
              "radial-gradient(circle at center, rgba(59,130,246,0.14), transparent 70%)",
            paddingBottom: 10,
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "0.96fr" : "1fr 380px",
              gap: 15,
              maxWidth: 880,
              alignItems: "start",
              justifyContent: isMobile ? "center" : "start",
            }}
          >
            {/* IMAGE CARD */}
            <div
              style={{
                borderRadius: 24,
                textAlign: "center",
              }}
            >
              <img
                src="/images/NEW-leadvision-hero-group.png"
                alt="LeadVision AI intake system"
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: 15,
                  objectFit: "cover",
                  paddingTop: 50,

                }}
              />
            </div>

            <div
                  style={{
                    marginTop: 5,
                    fontSize: 15,
                    color: "#64748b",
                    maxWidth: "100%",
                    textAlign: isMobile ? "center" : "left",
                    fontWeight: 500,
                  }}
                >
                  <div style={{
                      position: "relative",
                      marginBottom: 1,
                      padding: 10,
                      paddingTop: 15,
                      fontSize: 18,
                    }}>
                  We create quality customer leads by turning customer photos into structured estimates and clear next
                  steps — without phone calls, guessing, or wasted site visits.</div>

                  {/* LOGIN CARD */}
                  <div
                    style={{
                      position: "relative",
                      width: isMobile ? "95%" : 300,
                      maxWidth: isMobile ? "95%" : 300,
                      marginBottom: 1,
                      background: "#ffffff",
                      borderRadius: 24,
                      padding: 20,
                      paddingTop: 15,
                      boxShadow: "0 18px 36px rgba(0,0,0,0.16)",
                      zIndex: 5,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 22,
                        fontWeight: 700,
                        letterSpacing: "-0.02em",
                        textAlign: "left",
                      }}
                    >
                      LeadVision Login
                      
                    </div>


              <form onSubmit={handleLoginSubmit}>
                <label>Email</label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={inputStyle}
                />

                <label>Password</label>
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={passwordInputStyle}
                />

                <button
                  type="submit"
                  disabled={loading}
                  style={buttonStyle(loading)}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>

              <div style={{ marginTop: 12, fontSize: 14 }}>
                <Link to="/forgot-password">Forgot password?</Link>
              </div>

              <div style={{ marginTop: 10, fontSize: 14 }}>
                <Link to="/signup">Create Vendor Account →</Link>
              </div>
            </div>
                </div>

            
          </div>
        </section>

        {/* WHAT YOU’RE SUBSCRIBING TO */}
        <section style={{ marginTop: 10, marginBottom: 10 }}>
          <h2 style={sectionTitle}>What You’re Subscribing To</h2>

          <li style={listStyle}>
            An AI-powered estimate generator embedded on your own website
          </li>
          <li style={listStyle}>
            Prospective customer photos with automated item recognition and
            pricing
          </li>
          <li style={listStyle}>
            Structured estimates with automated weight, volume, and item counts
          </li>
          <li style={listStyle}>
            Clean handoff directly to your business — no need to sell to the
            customer!
          </li>

          <p style={mutedText}>
            Think of LeadVision as an AI receptionist and estimator — not a
            marketplace, not a lead broker, and not a guarantee engine.
          </p>
        </section>

        {/* SUPPORTED INDUSTRIES */}
        <section style={{ marginTop: 10, marginBottom: 10 }}>
          <SupportedIndustriesSection />
        </section>

        {/* PRICING */}
        <section style={{ marginTop: 10 }}>
          <PricingSection />
        </section>
      </div>
    </div>
  );
}

/* ---------- Shared Styles ---------- */

const inputStyle = {
  width: "60%",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  marginBottom: 12,
  outline: "none",
  marginLeft: 10,
};

const passwordInputStyle = {
  width: "40%",
  padding: "12px 14px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  marginBottom: 12,
  outline: "none",
  marginLeft: 10,
};

const buttonStyle = (loading) => ({
  width: "100%",
  padding: "12px",
  borderRadius: 10,
  border: "none",
  background: "#2563eb",
  color: "#ffffff",
  fontWeight: 600,
  cursor: loading ? "not-allowed" : "pointer",
  opacity: loading ? 0.7 : 1,
});

const sectionTitle = {
  fontSize: 24,
  fontWeight: 800,
  marginBottom: 10,
  paddingLeft: 8,
};

const mutedText = {
  maxWidth: 800,
  color: "#64748b",
  marginTop: 16,
  lineHeight: 1.6,
};

const listStyle = {
  maxWidth: 800,
  lineHeight: 1.8,
  color: "#334155",
  marginLeft: 15,
};


